import React, { useEffect } from 'react';
import { gql, useQuery } from "@apollo/client";
import jsPDF from 'jspdf';
import Total from './Total';
import GenerarFactura from './GenerarPDF'; 
import { useAuth0 } from '@auth0/auth0-react';
const GET_PEDIDOS = gql`
  query getPedidos {
    getPedidos {
      _id
      estado
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

function Inicio() {
  const { loading, error, data } = useQuery(GET_PEDIDOS);
  const { user, isAuthenticated, isLoading } = useAuth0();
  const roles = user && user[`${process.env.REACT_APP_AUTH0_NAMESPACE}/roles`];

  useEffect(() => {
    if (data && data.getPedidos) {
      data.getPedidos.forEach(pedido => {
        const element = document.getElementById(`pedido-${pedido._id}`);
        if (element) {
          
        }
      });
    }
  }, [data]);

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error</p>;

  const pedidos = data.getPedidos;

  return (
    <div>
          <input className='range' type="range" min="0" max="100" ></input>
        <Total></Total>
        
       

      
      
      { isAuthenticated && (
      <div>
       <h2>{user.name}</h2>
        <p>{user.email}</p>
      </div>
    )}
      {pedidos &&
        pedidos.map((pedido) => (
          <div key={pedido._id} id={`pedido-${pedido._id}`}>
            <h1>Número de Pedido: {pedido.numeroPedido}</h1>
            <h2>Estado: {pedido.estado}</h2>
            <p>Nombre del Cliente: {pedido.nombreCliente}</p>
            <p>Dirección del Cliente: {pedido.direccionCliente}</p>
            <p>WhatsApp del Cliente: {pedido.whatsappCliente}</p>
            <p>Nota del Pedido: {pedido.notaPedido}</p>
            <h3>Productos:</h3>
            <ul>
              {pedido.productos &&
                JSON.parse(pedido.productos).map((producto) => (
                  <li key={producto.id}> {producto.nombre} {producto.precio}
                  </li>
                  
                ))}
            </ul>
        
       </div>
        ))}
    </div>
  );
}

export default Inicio;
